import { render, staticRenderFns } from "./ChatAttachmentImage.vue?vue&type=template&id=2e43aa20"
import script from "./ChatAttachmentImage.vue?vue&type=script&lang=js"
export * from "./ChatAttachmentImage.vue?vue&type=script&lang=js"
import style0 from "./ChatAttachmentImage.vue?vue&type=style&index=0&id=2e43aa20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports